import { API_URL, getRequest, putRequest } from '@/assets/ts/helpers/api';
const getCurrentLotteryTicketAssignment = () => getRequest(`${API_URL}/admin/lottery-ticket/current`, true);
const getHistoryLotteryTicketAssignment = () => getRequest(`${API_URL}/admin/lottery-ticket/history`, true);
const assignNicknameToTicket = (assignedTicketId, nickname = null) => putRequest(`${API_URL}/admin/lottery-ticket/assign-nickname`, {
    lottery_assigned_ticket_id: assignedTicketId,
    nickname
}, true);
export { assignNicknameToTicket, getCurrentLotteryTicketAssignment, getHistoryLotteryTicketAssignment };
